import common from '../modules/common/locales/zh-CN';
import log from '../modules/log/locales/zh-CN';
import dict from '../modules/dict/locales/zh-CN';
import account from '../modules/account/locales/zh-CN';
import workflow from '../modules/workflow/locales/zh-CN';
import mail from "../modules/mail/locales/zh-CN";
import wechat from "../modules/wechat/locales/zh-CN";
import vms from "../modules/vms/locales/zh-CN";
import exos from "../modules/exos/locales/zh-CN";

const zh_CN = {
    ...common,
    ...log,
    ...dict,
    ...account,
    ...workflow,
    ...mail,
    ...wechat,
    ...vms,
    ...exos
}

export default zh_CN;